import type { FullActivityItem } from '@customTypes/types';
import { Avatar, AvatarGroup, Box, Divider, Flex, Text } from '@mantine/core';

import { resolveImagePath } from '@/shared/helper';

import styles from './TaskCard.module.css';

export const TaskCard = ({ task, ...props }: { task: FullActivityItem }) => (
  <Box {...props} className={styles.container}>
    <Flex align='center' gap={5}>
      <AvatarGroup>
        <Avatar
          size={30}
          src={task.artistPhoto ? resolveImagePath(task.artistPhoto) : ''}
        />
        <Avatar
          size={30}
          src={task.clubPhoto ? resolveImagePath(task.clubPhoto) : ''}
        />
      </AvatarGroup>
      <Flex gap={5} wrap='wrap'>
        <Text fw={500} fz={14}>
          {task.artistName}
        </Text>
        <Divider orientation='vertical' />
        <Text fw={500} fz={14}>
          {task.clubName}
        </Text>
      </Flex>
    </Flex>
  </Box>
);
